import locationRestService from '../services/location/LocationRestService'
import locationFunctions from '../services/location/LocationUtilsFunctions'
import { upsertCatalogOption } from '../services/common/CatalogOptions'

const state = {
  locations: [],
  baseLocations: [],
  locationTypes: [],
  filteredLocations: [],
  dialogActived: false,
  selectedItem: {
    id: -1,
    name: '',
    city: '',
    province: '',
    address: '',
    country: '',
    postalCode: '',
    obs: '',
    types: [],
    typeIds: []
  }
}

const getters = {
  getLocations: state => state.locations,
  getBaseLocations: state => state.baseLocations,
  getLocationTypes: state => state.locationTypes,
  getResposibleType: state => state.resposibleType,
  isDialogActived: state => state.dialogActived,
  getSelectedItem: state => state.selectedItem,
  getFilteredLocations: state => state.filteredLocations
}

const actions = {
  async getLocations (context) {
    try {
      let data = await locationRestService.getLocations()
      context.commit('setLocations', data)
    } catch (e) {
      console.log('Error fetching Locations')
    }
  },
  async getBaseLocations (context, { rejectOnError = false } = {}) {
    try {
      let data = await locationRestService.getBaseLocations()
      context.commit('setBaseLocations', data)
      return data
    } catch (e) {
      if (rejectOnError) throw e
      console.log('Error fetching Base Locations')
    }
  },
  async getLocationTypes (context) {
    const data = await locationRestService.getLocationTypes()
    context.commit('setLocationTypes', data)
    return data
  },
  async saveLocation (context, locationInfo) {
    let snackBarContent = {actived: true, message: 'Lugar Agregado/Modificado Exitosamente.', color: 'success'}
    try {
      const saved = await locationRestService.saveLocation(locationInfo)
      context.commit('upsertLocation', saved)
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
      return saved
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error Agregado/Modificado Lugar.', color: 'error'}
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
      throw e
    }
  },
  async removeLocation (context, id) {
    let snackBarContent = {actived: true, message: 'Lugar Eliminado Exitosamente.', color: 'success'}
    try {
      await locationRestService.removeLocation(id)
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
    } catch (error) {
      if (error.response.status === 424) {
        let notiDialogValue = {
          actived: true,
          title: 'Imposible borrar el item seleccionado',
          body: locationFunctions.getDependenciesMsg(error.response.data) }
        context.commit('setNotificationDialog', notiDialogValue, {root: true})
      } else {
        snackBarContent = {actived: true, message: 'Error Eliminando Lugar.', color: 'error'}
        context.commit('setSnackBarStatus', snackBarContent, {root: true})
      }
    }
  },
  async saveLocationType (context, locationType) {
    try {
      const saved = await locationRestService.saveLocationType(locationType)
      context.commit('setSnackBarStatus', {actived: true, message: 'Tipo de lugar guardado.', color: 'success'}, {root: true})
      return saved
    } catch (error) {
      context.commit('setSnackBarStatus', {actived: true, message: 'No se pudo guardar el tipo de lugar.', color: 'error'}, {root: true})
      throw error
    }
  },
  async removeLocationType (context, id) {
    try {
      await locationRestService.removeLocationType(id)
      context.commit('setSnackBarStatus', {actived: true, message: 'Tipo de lugar eliminado.', color: 'success'}, {root: true})
    } catch (error) {
      context.commit('setSnackBarStatus', {actived: true, message: 'No se pudo eliminar el tipo de lugar.', color: 'error'}, {root: true})
      throw error
    }
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  },
  setSelectedItem (context, selectedItem) {
    context.commit('setSelectedItem', selectedItem)
  },
  filterItems (context, filters) {
    context.commit('filterLocation', filters)
  },
  refreshFilteredLocations (context) {
    context.commit('refreshFilteredLocations')
  }
}

const mutations = {
  upsertLocation (state, saved) {
    for (const items of new Set([state.locations, state.baseLocations, state.filteredLocations])) {
      upsertCatalogOption(items, saved)
    }
  },
  setLocations (state, data) {
    state.locations = data
  },
  setBaseLocations (state, data) {
    state.baseLocations = data
  },
  setLocationTypes (state, data) {
    state.locationTypes = data
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setSelectedItem (state, selectedItem) {
    state.selectedItem = selectedItem
  },
  filterLocation (state, filters) {
    state.filteredLocations = locationFunctions.filterLocations(state.locations, filters)
  },
  refreshFilteredLocations (state) {
    state.filteredLocations = state.locations
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
